import React, { useState } from 'react';
import api from '../../services/api';
import { Button, TextField, Alert, Box } from '@mui/material';

const ResendVerification: React.FC = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleResend = async () => {
    setMessage('');
    setError('');
    setLoading(true);
    try {
      await api.post('/auth/send-verification', { email });
      setMessage('Verification email sent! Please check your inbox.');
    } catch (err) {
      setError('Failed to send verification email. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ mt: 2 }}>
      <TextField
        label="Email Address"
        value={email}
        onChange={e => setEmail(e.target.value)}
        fullWidth
        margin="normal"
        type="email"
        autoComplete="email"
      />
      <Button variant="contained" onClick={handleResend} disabled={loading || !email} fullWidth>
        {loading ? 'Sending...' : 'Resend Verification Email'}
      </Button>
      {message && <Alert severity="success" sx={{ mt: 2 }}>{message}</Alert>}
      {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}
    </Box>
  );
};

export default ResendVerification; 